// API fetch
import axios from "axios";
import { baseURL } from '../config/api-config.js';


async function getCreneaux(id) { //jour : get list of selected creneaux assigned to this resa

    axios.get(`${baseURL}/creneau-eleve/resa/${id}`)
            .then((response) => {
                if (response.status === 200) { // OK
                    const crens = response.data.data;
                    console.log(crens);
                    return crens;
                }
                else { //mail problème
                    return response.status
                }
            })
            .catch(error => {
                return error
            })
}


export default function filterCreneaux(creneaux,wallyEditor,creneauxResa) {
    
    let limit = wallyEditor===true?19:15;
    let creneauxDeBase = creneaux.filter((creneau) => creneau.horaire <= limit)

    if (creneauxResa.length>0 && wallyEditor===false){ //idResa > 0 : only for editing mode
        //console.log(creneauxResa); 
        creneaux.forEach((creneau)=>{
            if(creneau.horaire>15){ //only for creneaux over 15 
                if(creneauxResa.filter((cren)=>cren.creneau_id===creneau.id_creneau).length>0){ // if any creneau after 15 for this resa
                    //push
                    
                    creneauxDeBase.push(creneau);
                    console.log(creneauxDeBase); 
                    
                    
             }
            }
        })
     }

    return creneauxDeBase;  
 
    
}



